import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {DomainToolAddress, DomainToolCompany} from '@app/model/domain-tool/dcp-company.model';
import {DcpCustomerRegistrationAddressModel, DcpCustomerRegistrationDecoratorService, DcpCustomerRegistrationModel,} from '@app/services/dcp-customer-registration-decorator.service';
import {UserAccountChangedEvent, UserAccountFacade} from '@spartacus/user/account/root';
import {take} from 'rxjs/operators';
import {EventService, User} from '@spartacus/core';
import {Router} from '@angular/router';
import {UserRegistrationRedirectService} from '@app/services/user-registration/user-registration-redirect.service';
import {UserNameValidationService} from '@app/services/user-registration/user-name-validation.service';
import {UserRegistrationConfigService} from '@app/services/user-registration/user-registration-config.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-company-address-selection',
  templateUrl: './company-address-selection.component.html',
  styleUrls: ['./company-address-selection.component.scss']
})
export class CompanyAddressSelectionComponent {
  @Input() company: DomainToolCompany;
  @Output() companyChange = new EventEmitter();
  inProgress = false;
  addNewAddress = false;
  selectedAddress: DomainToolAddress;

  constructor(
    private registrationService: DcpCustomerRegistrationDecoratorService,
    private userAccountFacade: UserAccountFacade,
    private eventService: EventService,
    private router: Router,
    private userRegistrationRedirectService: UserRegistrationRedirectService,
    private userRegistrationConfigService: UserRegistrationConfigService,
    private userNameValidationService: UserNameValidationService,
    private cdr: ChangeDetectorRef) {
  }

  formatAddress(address: any) {
    return `${address.street}, ${address.city}`;
  }

  registerUser(selectedAddress: DomainToolAddress) {
    this.selectedAddress = selectedAddress;
    this.inProgress = true;
    this.userAccountFacade.get().pipe(take(1), untilDestroyed(this)).subscribe((user: User) => {
      const address = this.convertAddress(this.selectedAddress);
      address.company = this.company.displayName;
      const username = this.userNameValidationService.getValidUserName();
      address.firstName = username.firstName;
      address.lastName = username.lastName;
      address.lineOfBusiness = this.company.masterCode;

      const payload: DcpCustomerRegistrationModel = {
        b2bUnitUid: user.orgUnit?.uid,
        b2bCustomerUid: user.uid,
        customerId: user.customerId,
        addresses: [address],
        sapAccountId: this.selectedAddress.sapCustomerId,
      };
      this.registrationService.updateB2BUnit(payload).pipe(untilDestroyed(this)).subscribe(() => {
          this.router.navigateByUrl((this.userRegistrationRedirectService.getCurrent() || '/')).then(() => {
            this.userRegistrationRedirectService.resetNavigationUrl();
            this.userRegistrationConfigService.resetConfig();
          });
          this.eventService.dispatch(new UserAccountChangedEvent());
        },
        () => {
          this.selectedAddress = null;
          this.inProgress = false;
          this.cdr.detectChanges();
        }
      );
    });
  }

  convertAddress(address: DomainToolAddress): DcpCustomerRegistrationAddressModel {
    return {
      addressNumber: address.addressNumber,
      countryCode: address.countryCode,
      city: address.city,
      street: address.street,
      postalCode: address.postalCode,
      regionCode: address.regionCode,
    };
  }
}
